import { jsx as _jsx } from "react/jsx-runtime";
import CertifyAmazonConnector from '../../components/AmazonConnector/CertifyAmazonConnector';
function AmazonBusiness() {
    return _jsx(CertifyAmazonConnector, {});
}
export default AmazonBusiness;
